/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import {
  CreateUser,
  resetAddUserSlice,
} from "../../redux/Slice/Users/AddUserSlice";
import { AddUpdateUserForm } from "../../sub-modules/AddUpdateUserForm";
import { UserDataObjType } from "../../utilities/types";
import { ToastContainer, toast } from "react-toastify";

const AddUsers = () => {
  const [userData, setUserData] = useState<UserDataObjType>({
    firstName: "",
    lastName: "",
    roleId: "",
    phone: "",
    password: "",
    email: "",
    gender: "",
    birthDate: "",
    aadharNumber: "",
    isActive: "true",
    image: null,
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    landmark: "",
    userFacilities: [],
  });

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { message, status } = useAppSelector((state) => state.addUser);
  const [submitButton, setSubmitButton] = useState(false);

  const HandleSubmit = (payload: UserDataObjType) => {
    setSubmitButton(true);
    dispatch(CreateUser(payload));
  };
  useEffect(() => {
    if (!status) return;
    if (status == "200") {
      navigate("/users");
      dispatch(resetAddUserSlice());
    } else {
      toast.error(message);
      setSubmitButton(false);
      dispatch(resetAddUserSlice());
    }
  }, [status]);

  return (
    <>
      <AddUpdateUserForm
        submitButton={submitButton}
        buttonName="Add User"
        userData={userData}
        setUserData={setUserData}
        HandleSubmit={HandleSubmit}
      />
      <ToastContainer />
    </>
  );
};

export { AddUsers };
